import script from "./Videos.vue?vue&type=script&setup=true&lang=js"
export * from "./Videos.vue?vue&type=script&setup=true&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=6c3ff498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c3ff498"]])

export default __exports__